import { SessionTrait, TraitValue } from 'types'
import { TraitWithValues } from '../../../utils/traitUtils'
import { ISessionContext } from '../../providers'
import TraitGridSelector from './TraitGridSelector'
import TraitListSelector from './TraitListSelector'

export interface TraitSelectorProps {
  group: TraitWithValues
  getLanguageValue: ISessionContext['getLanguageValue']
  onSelect: (selection: TraitValue) => void
  selections: SessionTrait[]
}

export default function TraitSelector(props: TraitSelectorProps) {
  switch (props.group.displayType) {
    case 'list':
      return <TraitListSelector {...props} />
    default:
      return <TraitGridSelector {...props} />
  }
}
